import { EEventType } from './../enums/EEventType';
import OY from "../types/OY";

interface IJeactOption {
  /**
   * 是否自动执行同类render函数
   */
  autoRender?: boolean;
  /**
   * 打印时间
   */
  logTime?: boolean;

  asyncEvent?: boolean;
}

const defaultOption: IJeactOption = {
  autoRender: false,
  logTime: false,
  asyncEvent: false
}

export function jeact(option?: IJeactOption) {
  const ops = { ...defaultOption, ...option }

  return function <T extends Function>(target: T): T {
    const original = target;
    function construct(constructor: Function, args: any[]) {
      const Co: any = function (this: any) {
        if (ops.logTime) {
          console.time(constructor.displayName)
        }
        const [prop, ...others] = args;
        // eslint-disable-next-line prefer-const
        let { $parent, ...props } = prop;
        props = { ...(constructor as any).defaultProps, ...this.getAttrProps($parent), ...props };
        // debugger
        const instance = constructor.apply(this, [props].concat(others));
        this.$parent = $parent;
        this.props = props;

        this.bindPropsEvent(); // 自动绑定props传入的事件
        this.render(); // 渲染模板

        if (ops.logTime) {
          console.timeEnd(constructor.displayName)
        }
        return instance;
      }
      Co.prototype = constructor.prototype;
      return new Co();
    }

    // 自动绑定事件
    const bindEvents: any[] = [];
    for (const key in original.prototype) {
      if (Object.prototype.hasOwnProperty.call(original.prototype, key)) {
        const element = original.prototype[key];
        if (['bindAttris', 'bindEvent', 'bindPropsEvent'].indexOf(key) === -1 && /^bind[A-Z]/.test(key)) {
          bindEvents.push(element)
        }
      }
    }

    original.prototype['bindEvent'] = function bindEvent(this: any) {
      bindEvents.forEach(be => be.apply(this))
    };

    // console.log(original.prototype)
    // 绑定didMount、getDerivedStateFromProps声明周期函数
    const render = original.prototype.render;
    original.prototype.render = function (this: OY, nextProps?: any, propCb?: Function) {
      setTimeout(() => {
        if (!this._componentDidMount) {
          this._componentDidMount = true;
          this.componentDidMount && this.componentDidMount();
          this.eventEmitter.emit(EEventType.onComponentDidMount)
        } else {
          this.componentDidUpdate && this.componentDidUpdate()
        }
      })

      // 第一次渲染或者有新的props的时候执行
      let np = nextProps;
      if (this.getDerivedStateFromProps) {
        // 如果是首次挂载的话。需要手动赋值np为this.prop
        if (!np && !this._componentDidMount) {
          np = this.props;
          this.props = null as any;
        }

        if (np) {
          const state = this.getDerivedStateFromProps(np, this.state);
          this.props = np;
          if (!state) {
            return;
          }
          this.state = state;
        }
      } else if (nextProps) {
        this.props = nextProps;
      }

      this.componentWillRender && this.componentWillRender(); // 执行 componentWillRender

      // 执行render函数
      const result = render.apply(this);
      if (result && typeof result === 'string') {
        this.$el = $(result);
      }
      // 自动执行其余render函数
      if (ops.autoRender) {
        const rednerKeys = Object.keys(Object.getPrototypeOf(this)).filter(key => /^render[A-Z]/.test(key));
        rednerKeys.forEach(name => {
          (this as any)[name]();
        })
        // console.log(rednerKeys)
      }

      // 做收尾工作
      this.bindAttris();
      this.setNode()
      if (!ops.asyncEvent) {
        this.bindEvent!()
      }

      this.componentAfterRender && this.componentAfterRender(); // 执行componentAfterRender生命周期
      this.$parent.replaceWith(this.$el); // 挂载DOM
      this.$parent = this.$el; // 需要替换掉DOM

      // 处理回调
      if (propCb && typeof propCb === 'function') {
        propCb.apply(this);
      }
      setTimeout(() => {
        this.eventEmitter.emit(EEventType.onRender)
        if (ops.asyncEvent) {
          this.bindEvent!()
        }
      })
    }

    // const setProp = original.prototype.setProp;
    original.prototype.setProp = function (this: any, data: any, cb?: Function) {
      this._nextProps = { ...this.props, ...this._nextProps, ...data }; // 存入_nextProps。用于合并多次setProp
      if (this.setDataTimeout) {
        clearTimeout(this.setDataTimeout)
        this.setDataTimeout = 0;
      }
      this.setDataTimeout = setTimeout(() => {
        this.render(this._nextProps, cb);
        this._nextProps = undefined;
      })
      // setProp.apply(this, args)
    }

    const fn: any = function (...args: any[]) {
      // console.log(`New: ${original['name']} is created`);
      return construct(original, args);
    }

    fn.prototype = original.prototype;
    fn.displayName = (original as any).displayName;
    return fn;
  }
}




// WEBPACK FOOTER //
// ./src/decorators/jeact.ts